'use strict';

var InviteToSiteActions = function InviteToSiteActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('InviteToSiteActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'InviteToSite',
    purpose: 'Show share site dialog',
    payload: []
  });

  Actions.add({
    name: 'CancelInviteToSite',
    purpose: 'Cancel site dialog',
    payload: []
  });

  return Actions;
};

InviteToSiteActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = InviteToSiteActions;


// WEBPACK FOOTER //
// ./src/app/dash/invite/InviteToSiteActions.js